import { createContext, useContext, useEffect, useState } from "react";
import { adminApi } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("trio_admin_token");
    if (!token) {
      setLoading(false);
      return;
    }
    adminApi
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("trio_admin_token");
        localStorage.removeItem("trio_admin_user");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  async function login(email, password) {
    const { data } = await adminApi.post("/auth/login", { email, password });
    localStorage.setItem("trio_admin_token", data.access_token);
    localStorage.setItem("trio_admin_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  }

  async function bootstrapFromToken() {
    // Called after signup — token is already in localStorage, hydrate user from /auth/me
    try {
      const { data } = await adminApi.get("/auth/me");
      setUser(data);
      return data;
    } catch (_) {
      setUser(null);
      return null;
    }
  }

  function logout() {
    localStorage.removeItem("trio_admin_token");
    localStorage.removeItem("trio_admin_user");
    setUser(null);
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, bootstrapFromToken }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
